import { useRouter } from "next/router";
import translatedRoutedSlugs from "translatedRouteSlugs";
import { ArrowIcon } from "../../../../common/Icons/ArrowIcon";
import { useDesktopNavLink } from "../../DesktopNavigation/DesktopNavLink/useDesktopNavLink";
import { NavLinkParent } from "../../NavLinkParent/NavLinkParent";
import { isNavColumns, NavChild, NavLinkProps } from "components/modules/Navigation/navLinks";

export const MobileNavLink = ({
    link,
    title,
    isEditor,
    subItems,
    isChild = false,
    outlink,
    urlMatcher,
}: NavLinkProps) => {
    const { isFocused, setIsFocused, isActive } = useDesktopNavLink(subItems, isChild, link, urlMatcher);
    const hasChildren = subItems && subItems.length > 0;
    const { locale } = useRouter();
    // External links (e.g. the ClipSnap AI tools) must keep their absolute URL.
    if (!outlink) {
        link =
            link === "/"
                ? "/"
                : "/" + ((translatedRoutedSlugs as any)[link]?.[locale ?? "en"] ?? link.replaceAll("/", ""));
    }

    return (
        <li onClick={() => hasChildren && setIsFocused(!isFocused)} className="w-full">
            <NavLinkParent
                link={link}
                isChild={isChild}
                isParent={!!hasChildren}
                outlink={outlink}
                twClasses={`${!isChild && `border-b-slate-200 border-b dark:border-b-darkSurface-300`}`}
                isEditor={!!isEditor}
            >
                <div className={`whitespace-nowrap ml-2 ${isActive ? "font-semibold" : ""}`}>{title}</div>
                {subItems &&
                    subItems.length &&
                    (isFocused ? (
                        <div className="ml-2 rotate-180">
                            <ArrowIcon />
                        </div>
                    ) : (
                        <div className="ml-2">
                            <ArrowIcon />
                        </div>
                    ))}
            </NavLinkParent>
            {hasChildren && isFocused && (
                <ul className="flex flex-col justify-start py-4 ml-8">
                    {isNavColumns(subItems)
                        ? subItems.map((column, columnIndex) => (
                              <li key={columnIndex} className="w-full">
                                  {column.header && (
                                      <div className="ml-2 px-3 py-4 font-bold text-black dark:text-white">
                                          {column.header}
                                      </div>
                                  )}
                                  <ul className="flex flex-col justify-start">
                                      {column.items.map((item, index) => (
                                          <MobileNavLink
                                              link={item.link}
                                              title={item.title}
                                              isChild={true}
                                              outlink={item.outlink}
                                              key={index}
                                              isEditor={isEditor}
                                              urlMatcher={item.urlMatcher}
                                          />
                                      ))}
                                  </ul>
                              </li>
                          ))
                        : subItems &&
                          (subItems as NavChild[]).map((item, index) => {
                              return (
                                  <MobileNavLink
                                      link={item.link}
                                      title={item.title}
                                      isChild={true}
                                      outlink={item.outlink}
                                      key={index}
                                      isEditor={isEditor}
                                      urlMatcher={item.urlMatcher}
                                  />
                              );
                          })}
                </ul>
            )}
        </li>
    );
};
